module.exports = __webpack_public_path__ + "img/hall-of-fame_5.86cdaf6d.jpg";